(function($, undefined) {
	'use strict';
	var form;
	var sliders;
	
	var init = function() {
		$('.public-auditions-com').each(function() {
			var slider = $('.auditions-list', this);
			var prevArrow = $('.slider-btn.prev', this);
			var nextArrow = $('.slider-btn.next', this);

			slider.slick({
				infinite: true,
				slidesToShow: 2,
				slidesToScroll: 1,
				variableWidth: true,
				swipeToSlide: true,
				dots: false,
				prevArrow,
				nextArrow,
				responsive: [
					{
						breakpoint: 480,
						settings: {
							slidesToShow: 1,
							variableWidth: false
						}
					}
				]
			});
		});
	};
	
	$(window).ready(function () {
		init();
	});

})(jQuery);

